<template>
  <div>
      <!-- Shopping list -->
      <b-tooltip
        v-if="ingredient.recipe_id"
        type="is-light"
        position="is-bottom"
        size="is-large">
      <p :class="styleClass" @click="viewRecipe"><i>{{optionalString}}</i>{{ amountString }} <b>{{ ingredientString }}</b> {{prepString}}</p>
      <template v-slot:content>
        <b>Click to view recipe: {{ ingredient.recipe_id }}</b>
      </template>
    </b-tooltip>
      <!-- In recipe -->
      <p v-if="!ingredient.recipe_id"><i>{{optionalString}}</i>{{ amountString }} <b>{{ ingredientString }}</b> {{prepString}}</p>
      <InlineTips v-if="showTips" :tips="ingredient.tips" />
  </div>
</template>

<script>
import InlineTips from './InlineTips';

export default {
  name: 'IngredientItem',
  components: {
    InlineTips
  },
  props: {
    ingredient: {},
    showTips: {
      default: true
    },
    ratio: {
      default: 1.0
    }
  },
  computed: {
    optionalString() {
      return this.ingredient.optional ? "(Optional) " : ""
    },
    amount() {
      return parseFloat((this.ingredient.amount * this.ratio).toFixed(4)) ?? 1.0
    },
    amountString() {
      return "" + this.amount + " " + this.ingredient.unit
    },
    ingredientString() {
      return this.ingredient.name?.toLowerCase() ?? ""
    },
    hasPrep() {
      if (typeof this.ingredient.prep !== 'undefined') {
        if (this.ingredient.prep == ""){
          return false
        }else {
          return true
        }
      }
      return false
    },
    prepString() {
      return this.ingredient.prep ? `(${this.ingredient.prep})` : ""
    },
    hasIssue() {
      const unit = this.ingredient.unit;
      return ((unit == null || unit == "" || unit.includes("bunch") || unit.includes("head")) && (this.ingredient.amount % 1 != 0));
    },
    styleClass(){
      return `${this.hasIssue ? "is-error":""}`;
    }
  },
  methods: {
    viewRecipe() {
      if (this.ingredient.recipe_id != null){
        this.$router.push({ name: 'RecipeView', params: { id: this.ingredient.recipe_id } })
      }
    }
  }
}
</script>

<style scoped>
  .is-error {
    color: red;
  }
</style>
